export default "<p>\r\n  detalle-linea works!\r\n</p>\r\n"